<template>
  <div class="rightMenu">
    <div v-if="!isclick" class="clickBefore">
      <div class="clickMe">请尝试点击我</div>
      <img @click="isclick = true" src="@/assets/image/index/astronaut1.png" alt="" />
    </div>
    <div v-if="isclick" :class="['clickAfter',isclick ? 'show' : '']">
      <img @click="isclick = false" src="@/assets/image/index/astronaut2.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isclick:false
    };
  },
  mounted() {},
  beforeDestroy() {},
  methods: {}
};
</script>

<style scoped lang="scss">
.rightMenu {
  position: fixed;
  right: 0;
  bottom: 1.8rem;
  .clickBefore {
    height: 1.32rem;
    img {
      width: 1.05rem;
      height: 1.24rem;
      position: absolute;
      right: -0.48rem;
      cursor: pointer;
      top: 0.3rem;
    }
  }
  .clickMe {
    width: 1.22rem;
    height: 0.4rem;
    line-height: 0.4rem;
    // background: rgba(0, 0, 0, 0.36);
    background: #505050;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
    color: #fff;
    font-size: 0.16rem;
    text-align: center;
    border-radius: 0.12rem;
    margin-right: 0.3rem;
  }
  .clickAfter {
    width: 0.64rem;
    height: 1.32rem;
    img {
      width: 0.64rem;
      height: 1.06rem;
      position: absolute;
      right: -0.64rem;
      opacity: 0;
      cursor: pointer;
      transition: all 0.3s ease-in-out;
    }
    &.show{
      img{
        opacity: 1;
        right: 0.2rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/astronaut/index.vue